export default {
  "homeScreen": {
    "farm": "Trại đơn lẻ",
    "label": "Chọn trang trại",
    "noFarm": "Không trại nuôi nào",

    "fetchingData": "Hiện đang tìm dữ liệu ...",
    "pleaseWait": "Vui lòng chờ",
    "noConnection": "Không thể hiển thị kết quả. Vui lòng kiểm tra kết nối internet và truy cập lại trang.",

    "emptyFarm": "Chưa có bất kỳ trại đơn lẻ",
    "emptyPond": "Chưa có bất kỳ trại nuôi nào",
    "emptyCycle": "Chưa có bất kỳ nào đang hoạt động",
    "createFarm": "Bắt đầu nuôi",
    "createPond": "Tạo ao",
    "createCycle": "Bắt đầu chu kỳ",

    "predictionBiomass": "Ước tính sinh khối",
    "actualFeedAccumulation": "Tổng lượng thức ăn",
    "predictionSR": "Ước tính tỷ lệ sống SR",
    "predictionPrice": "Giá bán",
    "predictionWeight": "Ước tính MBW",
    "from": "từ ngày ",
    "activePonds": " các ao đang hoạt động",

    "disclaimer": "Ước tính không chính xác. Hoàn thiện dữ liệu nguồn cấp dữ liệu để cải thiện độ chính xác của ước tính",

    "monitoring": "Giám sát",
    "pond": "Tên ao",
    "finance": "Tài chính",
    "price": "giá bán",
    "news": "Tin tức",
    "disease": "Bệnh dịch",
    "asto": "Asto",
    "predictions": "Dự đoán",
    "beta": "Bê-ta",
    "autoFeeder": "Auto Feeder",
    "shrimpPrice": "Giá tôm",
    "appMenusTitle": "Thử nhiều tính năng hơn",
    "seeAll": "Xem tất cả",
    "shrimpNews": "Thông tin về tôm nuôi",
    "consultTitle": "Cần tham khảo ý kiến?",
    "consultSubtitle": "Bây giờ bạn có thể tham khảo về việc trồng trọt thông qua ứng app.",
    "consultButton": "Hỏi tại",
    "youtubeTutorial": "Xem hướng dẫn trên Ứng dụng Jala",
    "telegramTutorial": "Tham gia nhóm thảo luận",
    "helpTutorial": "Trung tâm trợ giúp",
    "bannerTitle": "Các giải pháp nuôi tôm khác",
    "bottomTitle": "Hướng dẫn nuôi tôm với Ưng dụng Jala",
    "overview": "Thông tin chung",
    "partner": "Đối tác Jala",
    "firstTooltip": "Xem dự đoán từ kết quả nhập dữ liệu mà bạn thực hiện",
    "secondTooltip": "Quản lý nuôi tôm với menu này",
    "thirdTooltip": "Xem dự đoán từ kết quả nhập dữ liệu mà bạn thực hiện",
    "fourthTooltip": "Nhận thông tin giá tôm mới nhất tại đây",
    "fifthTooltip": "Thông tin tin tôm mới nhất tại đây",
    "tooltipSkip": "Nhảy",
    "tooltipNext": "Kế tiếp",
    "tooltipPrevious": "Trước",
    "notifications": "Thông báo",
    "simulation": "Mô phỏng",
    "chemicalPredictions": "Dự đoán Hóa học",
    "predictions": "Dự đoán",
    "newLabel": "Mới",
    "activity": "Hoạt động",

    "startCultivationTitle": "Quản lý trang trại nuôi bằng Jala",
    "startCultivation": "Bắt Đầu Tu Luyện",

    "alertNoFarmTitle": "Bạn cần phải có trại nuôi",
    "alertNoFarmDescription": "Bạn chỉ có thể truy cập tính năng ghi nhật ký nhanh nếu bạn đã có trại nuôi.",
    "alertNoActiveCycleTitle": "Không có chu kỳ hoạt động nào",
    "alertNoActiveCycleDescription": "Bắt đầu chu kỳ để nạp dữ liệu.",
    "alertStartCultivationTitle": "Thay đổi sang chế độ nuôi trồng",
    "alertStartCultivationDescription": "Để truy cập tính năng nuôi trồng, hãy thay đổi cài đặt hiển thị trong menu: Tài khoản - Trợ giúp - Cá nhân - sau đó chọn Quản lý Nuôi trồng.",

    "reminderActivity": "Nhấn để hoàn thành việc cần làm của bạn",
    "pro": "Pro",

    "occupationModalTitle": "Xin chào {{user}}!",
    "occupationModalSubtitle": "Hoàn thành dữ liệu hồ sơ của bạn để có trải nghiệm tốt hơn với Ứng dụng JALA",

    "offline": "Ngoại Tuyếne"
  },

  "modelCreateScreen": {
    "areYouSure": "Bạn có chắc xóa không?",
    "areYouSureYouWantToSomething": "Bạn có chắc chắn muốn %{something}?",

    "deleteSomething": "xóa %{something}",
    "thisData": "dữ liệu này không"
  },

  "farmCreateScreen": {
    "title": "Tạo Trại Nuôi",

    "disconnectedModalTitle": "Bạn Không Kết Nối",
    "disconnectedModalSubtitle": "Ứng dụng phát hiện một kết nối yếu, vui lòng đảm bảo bạn đã kết nối với Internet"
  },
  "farmEditScreen": {
    "title": "Cài Đặt Trại Nuôi",
  },

  "pondCreateMultipleScreen": {
    "title": "Tạo Ao"
  },

  "cycleCreateMultipleScreen": {
    "title": "Bắt Đầu Chu Kỳ",

    "deleteCycle": "Xóa chu kỳ",
    "deleteCycleSubtitle": "Cảnh báo! Bạn sẽ không thể truy cập dữ liệu chu kỳ đã xóa",
    "deleteCycleModalTitle": "Bạn có chắc không?",
    "deleteCycleModalSubtitle": "Bạn sẽ không truy cập được chu kỳ bị xóa này",
  },

  "farmShrimpPriceCreateScreen": {
    "title": "Thiết lập giá bán",
  },

  "overviewScreen": {
    "setting": "Cài đặt",
    "total": "Tổng cộng",
    "average": "Trung bình",
    "fromActivePonds": "từ %{count} ao hoạt động",
    "disclaimer": "Hoàn thành nguồn cấp dữ liệu và dữ liệu lấy mẫu để cải thiện độ chính xác của ước tính."
  },
  "overviewTotalWeightPredictionListScreen": {
    "title": "Ước tính sinh khối",
  },
  "overviewHarvestAccumulationWeightActualListScreen": {
    "title": "Tổng thu hoạch",
  },
  "overviewFeedAccumulationActualListScreen": {
    "title": "Tổng nguồn cấp dữ liệu",
  },
  "overviewSurvivalRatePredictionListScreen": {
    "title": "Ước tính SR",
  },
  "overviewSellingPricePredictionListScreen": {
    "title": "Ước tính giá bán",
    "source": "Nguồn giá bán: "
  },

  "shrimpPriceScreen": {
    "size": "Đếm",
    "close": "Đóng",
    "country": "Quốc gia",
    "location": "Địa điểm",
    "update": "Cập nhật giá",
    "all": "Tất cả các",
    "verified": "Đã xác minh",
    "unverified": "chưa được xác minh",
    "supplier": "nhà cung cấp",
    "findLoc": "Tìm vị trí",
    "cancel": "Hủy bỏ",
    "latest": "Mới nhất",
    "week": "> 1 Tuần",
    "month": "> 1 Tháng",
    "createPrice": "Tạo Giá Tôm",
    "name": "Tên",
    "phone": "Số điện thoại",
    "species": "Loài",
    "province": "Địa bàn tỉnh",
    "city": "Thành phố",
    "next": "Tiếp theo",
    "save": "Tiết kiệm",
    "shrimpPriceList": "Bảng Giá Tôm",
    "createdAt": "Ngày",
    "date": "Ngày",
    "currency": "Tiền tệ",
    "currencyId": "Tiền tệ",
    "sizeInput": "Kích thước Giá",
    "remark": "ghi chú (không bắt buộc)",
    "disclaimer": "Tôi xin chịu trách nhiệm về thông tin giá tôm do tôi thực hiện và đăng tải trên Jala",
    "size200": "Đếm 200",
    "size190": "Đếm 190",
    "size180": "Đếm 180",
    "size170": "Đếm 170",
    "size160": "Đếm 160",
    "size150": "Đếm 150",
    "size140": "Đếm 140",
    "size130": "Đếm 130",
    "size120": "Đếm 120",
    "size110": "Đếm 110",
    "size100": "Đếm 100",
    "size90": "Đếm 90",
    "size80": "Đếm 80",
    "size70": "Đếm 70",
    "size60": "Đếm 60",
    "size50": "Đếm 50",
    "size40": "Đếm 40",
    "size30": "Đếm 30",
    "size20": "Đếm 20",

    "size150Placeholder": "giá đầu vào",
    "size140Placeholder": "giá đầu vào",
    "size130Placeholder": "giá đầu vào",
    "size120Placeholder": "giá đầu vào",
    "size110Placeholder": "giá đầu vào",
    "size100Placeholder": "giá đầu vào",
    "size90Placeholder": "giá đầu vào",
    "size80Placeholder": "giá đầu vào",
    "size70Placeholder": "giá đầu vào",
    "size60Placeholder": "giá đầu vào",
    "size50Placeholder": "giá đầu vào",
    "size40Placeholder": "giá đầu vào",
    "size30Placeholder": "giá đầu vào",
    "size20Placeholder": "giá đầu vào",

    "datePlaceholder": "Chọn ngày",
    "remarkPlaceholder": "Ví dụ: Giá BS 60 % so với giá bình thường",
    "currencyPlaceholder": "Chọn...",
    "currencyIdPlaceholder": "Chọn...",
    "namePlaceholder": "Tên của bạn",
    "phonePlaceholder": "-",
    "speciesPlaceholder": "Chọn...",
    "countryPlaceholder": "Chọn...",
    "provincePlaceholder": "Chọn...",
    "provinceLabel": "Chọn Địa bàn tỉnh",
    "cityPlaceholder": "Chọn...",
    "sizePlaceholder": "Trên danh nghĩa",
    "partner": "Đối tác JALA",
    "priceList": "Bảng giá",
    "contact": "Tiếp xúc",
    "seeContact": "Tiếp xúc",
    "anotherPrice": "Giá ở khu vực khác",
    "implement": "Thực hiện",

    "dateValidation": "Ngày phải được điền",
    "currencyValidation": "Đơn vị tiền tệ phải được điền",
    "sizeValidation": "Kích thước 100 phải được lấp đầy",
    "phoneValidationLength": "Định dạng điện thoại không hợp lệ",
    "selectAll": "Chọn tất cả"
  },
  "shrimpPriceListScreen": {
    "title": "Giá Tôm",

    "listShrimpPrice": "Bảng Giá Tôm",
    "createPrice": "Làm Giá",
    "partner": "Đối tác JALA",
    "listEmptyTitle": "Shrimp prices in the location you are looking for can't be found.",
    "listEmptySubtitle": "Try to find other locations to find shrimp prices.",
    "searchLocation": "Tìm Vị Trí",
  },
  "shrimpPriceDetailScreen": {
    "title": "Giá Tôm",

    "unverified": "Chưa Được Xác Minh",
    "verified": "Đã xác minh",
    "partner": "Đối tác JALA",

    "contact": "Liên Hệ",
    "seeContact": "Cuộc Gọi",

    "priceList": "Bảng Giá",
    "anotherPrice": "Giá Khu Vực Khác",
  },

  "waterQualityMultiMeasurementCreateScreen": {
    "title": "Thêm dữ liệu chất lượng nước"
  },
  "waterQualityMultiMeasurementEditScreen": {
    "title": "Chỉnh sửa dữ liệu chất lượng nước"
  },
  "feedCreateScreen": {
    "title": "Thêm dữ liệu thức ăn"
  },
  "feedEditScreen": {
    "title": "Chỉnh sửa dữ liệu nguồn cấp dữ liệu"
  },
  "feedingTrayControlCreateScreen": {
    "title": "Thêm dữ liệu khay nạp"
  },
  "feedingTrayControlEditScreen": {
    "title": "Chỉnh sửa dữ liệu khay nạp"
  },
  "mortalityCreateScreen": {
    "title": "Thêm dữ liệu tử vong"
  },
  "mortalityEditScreen": {
    "title": "Chỉnh sửa dữ liệu tử vong"
  },
  "chemicalMultiMeasurementCreateScreen": {
    "title": "Thêm dữ liệu hóa học"
  },
  "chemicalMultiMeasurementEditScreen": {
    "title": "Chỉnh sửa dữ liệu hóa học"
  },
  "planktonMultiMeasurementCreateScreen": {
    "title": "Thêm dữ liệu sinh vật phù du"
  },
  "planktonMultiMeasurementEditScreen": {
    "title": "Chỉnh sửa dữ liệu sinh vật phù du"
  },
  "microbiologyMultiMeasurementCreateScreen": {
    "title": "Thêm dữ liệu vi sinh"
  },
  "microbiologyMultiMeasurementEditScreen": {
    "title": "Chỉnh sửa dữ liệu vi sinh"
  },
  "cycleDiseaseListScreen": {
    "seeRelatedDiseaseInfo": "Xem thông tin bệnh liên quan"
  },
  "cycleDiseaseCreateScreen": {
    "title": "Thêm dữ liệu",
    "seeDiseaseInfo": "Xem thông tin bệnh"
  },
  "cycleDiseaseEditScreen": {
    "title": "Chỉnh sửa dữ liệu",
    "seeDiseaseInfo": "Xem thông tin bệnh"
  },
  "cycleEditScreen": {
    "title": "Chỉnh sửa dữ liệu chu kỳ"
  },

  "cycleHarvestListScreen": {
    "closeCycle": "Đóng chu kỳ"
  },

  "cycleCloseScreen": {
    "title": "Đóng chu kỳ"
  },
  "cycleCloseMultipleScreen": {
    "title": "Đóng nhiều chu kỳ"
  },
  "cycleGraphScreen": {
    "title": "đồ thị chu kỳ"
  },
  "financeScreen": {
    "title": "Tài chính",
    "ongoingFeatureTitle": "Jali đang tiếp tục làm mới công nghệ và dịch vụ của mình.!",
    "ongoingFeatureSubtitle": "Cảm ơn bạn sử dụng JALA App. Tính năng này vẫn đang được phát triển. Thành viên Kiêm Cương và Người dùng Cycle Pro vẫn có thể sử dụng các tính năng tài chính trong ứng dụng web.",
    "openWeb": "Mở ứng dụng web",
    "learnProCycle": "Tìm hiểu về Pro Cycle",
  },
  "simulationScreen": {
    "title": "Mô phỏng",
    "emptyTitle": "Không có mô phỏng",
    "emptySubtitle": "Mô phỏng đã lưu sẽ được hiển thị ở đây.",
    "biomassHeader": "Sinh khối (kg)",
    "priceHeader": "Tổng giá",
    "createSimulation": "Tạo mô phỏng",
    "listTitle": "Danh sách mô phỏng",
    "totalSeed": "Tổng số hạt giống",
    "survivalRate": "Mục tiêu tỷ lệ sống sót",
    "biomassEstimation": "Ước tính sinh khối",
    "edit": "Chỉnh sửa",
    "delete": "Xóa bỏ",
    "name": "Tên mô phỏng",
    "wide": "Trang trại rộng (m²)",
    "date": "Ngày",
    "seed": "Tổng số hạt giống",
    "periode": "Thời kỳ thu hoạch",
    "maxBiomass": "Sinh khối tối đa (kg/m²)",
    "survival": "Tỷ lệ sống (%)",
    "size100": "SIze ở ngày thứ 100 (tail/kg)",
    "feedPrice": "Giá thức ăn cho mỗi kg",
    "currency": "Tiền tệ",
    "addPartial": "Thêm gói một phần",
    "partialPlan": "Kế hoạch từng phần",
    "age": "Tuổi tác (ngày)",
    "percent": "Phần trăm",
    "addPlan": "Thêm kế hoạch",
    "cancel": "Hủy bỏ",
    "show": "Trình diễn",
    "inputTitle": "Dữ liệu mô phỏng đầu vào",
    "inputAge": "Tuổi đầu vào",
    "inputPercent": "Phần trăm đầu vào",
    "SimulationTabTitle": "Kết quả mô phỏng",
    "HarvestPriceDisclaimer": "Tổng giá thu hoạch vẫn còn trống, do bảng giá chưa được lấp đầy.",
    "inputPrice": "Bảng giá đầu vào",
    "priceSimulation": "Mô phỏng giá tôm",
    "locationDisclaimer": "Chọn vị trí để nhận mô phỏng giá thu hoạch của bạn.",
    "location": "Địa điểm",
    "chooseLocation": "Chọn bộ lọc vị trí",
    "inputPriceTag": "Giá đầu vào",
    "FeedTabTitle": "Chiếu đầu ra nguồn cấp dữ liệu",
    "FeedChartTitle": "Thức ăn (kg)",
    "FeedPerfectData": "Thức ăn SR 100% (kg)",
    "BiomassChartTitle": "Tổng sinh khối sống",
    "BiomassChartLegend": "Tổng sinh khối sống (ton)",
    "BiomassMaxPerArea": "Sinh khối tối đa trên mỗi khu vực (ton)",
    "BiomassPerfectData": "Tổng sinh khối SR 100% (ton)",
    "FeedPriceTotal": "Tổng giá nguồn cấp dữ liệu",
    "seeFeedTab": "Xem bảng nguồn cấp dữ liệu",
    "deleteTitle": "Xóa mô phỏng?",
    "deleteSubtitle": "Bạn có chắc muốn xóa không {{simulation}}?",
    "namePlaceholder": "Simulation {{date}}",
    "widePlaceholder": "1000 m²",
    "seedPlaceholder": "100000 đuôi",
    "periodePlaceholder": "120 ngày",
    "biomassPlaceholder": "1,2 kg/m²",
    "survialPlaceholder": "100%",
    "sizePlaceholder": "45",
    "feedPlaceholder": "Rp 15000",
    "currencyPlaceholder": "Indonesia",
    "showPrice": "Xem giá",
    "save": "lưu mô phỏng",
    "searchSimulation": "Danh sách mô phỏng tìm kiếm...",
    "showBiomasstable": "Hiển thị bảng sinh khối",
    "biomasAxisY": "Tích lũy thức ăn 100% SR (tấn)",
    "axisX": "Ngày",
    "feedAxisY": "100% SR Cho ăn (kg)",
    "TotalHarvest": "Tổng Thu Hoạch",
    "quantityShort": "cái đuôi",
    "HarvestTab": "Thu hoạch",
    "FeedTab": "Thức ăn",
    "BiomassTab": "Sản lượng",
    "DateDOCHeader": "Số gày nuôi(DoC)",
    "Size": "Kích cở",
    "TotalBiomass": "Tổng sản lượng (kg)",
  },
  "customFRScreen": {
    "title": "Chỉnh sửa bảng FR",
    "create": "Tạo bảng FR của bạn",
    "here": "nơi đây"
  },
  "parameterListScreen": {
    "title": "Danh sách thông số",
    "info": "Bạn chỉ có thể hiển thị tối đa 3 thông số trên ứng dụng Jala di động. Để xem toàn bộ dữ liệu vui lòng sử dụng ứng dụng Jala trên website (https://app.jala.tech)",
    "chemical": "Hóa học",
    "plankton": "Sinh vật phù du",
    "microbio": "Vi sinh vật"
  },
  "cycleToDoScreen": {
    "title": "Hoạt động hàng ngày",
    "empty": "Chưa có hoạt động nào",
    "emptyFarm": "Tính năng này không khả dụng vì bạn không có trang trại",
    "emptyPond": "Tính năng này không khả dụng vì bạn không có ao",
    "emptyCycle": "Tính năng này không khả dụng vì bạn không có chu kỳ hoạt động",
    "infoTitle": "để làm tính năng",
    "info": "Giúp bạn quản lý các hoạt động canh tác hàng ngày của mình và giúp ghi lại dữ liệu canh tác hàng ngày dễ dàng như một lời nhắc nhở. Bạn có thể hoàn thành các hoạt động hàng ngày bằng cách ghi dữ liệu trồng trọt hàng ngày theo các hoạt động có sẵn, chẳng hạn như cho ăn, kiểm tra chất lượng nước, xử lý và thu hoạch.",
    "feeding": "Cho ăn",
    "measuring": "Kiểm tra chất lượng nước",
    "treatment": "điều trị",
    "feeding_tray_control": "Kiểm tra khay ăn",
    "sampling": "kiểm tra lấy mẫu",
    "mortality": "Ghi nhận tử vong",
    "harvest_partial": "thu hoạch một phần",
    "harvest_total": "Tổng thu hoạch",
    "inputDoc": "Phạm vi DoC đầu vào",
    "until": "cho đến khi",
    "addActivity": "Thêm hoạt động",
    "addActivityNote": "Bạn có chắc chắn muốn thêm {{activity}} vào hoạt động hàng ngày của mình không?",
    "incomplete": "chưa hoàn thành",
    "missed": "Bỏ lỡ",
    "complete": "Hoàn thành",
    "closed": "Chu kỳ đóng",
    "seeOthers": "Xem hoạt động khác",
    "seeLess": "Thấy ít",
    "changeActivityStatus": "Thay đổi trạng thái hoạt động",
    "setting": "Cài đặt hoạt động",
    "changeStatus": "Thay đổi trạng thái",
    "saveSetting": "Lưu cài đặt",
    "morningRecord": "Kiểm tra buổi sáng",
    "eveningRecord": "kiểm tra buổi tối",
    "settingWarning": "Hoạt động đã chọn sẽ xuất hiện trên trang hoạt động hàng ngày của bạn.",
    "settingTitle": "Thêm hoạt động hàng ngày",
    "rangeDoc": "Phạm vi DoC là bắt buộc",
    "rangeDocMax": "Phạm vi DoC không quá 130",
    "rangeDocFrom": "Từ DoC",
    "rangeDocTo": "Cho đến khi DoC",
    "lessThan130": "{{field}} phạm vi phải nhỏ hơn 130",
    "emptySearchTitle": "Ao không tìm thấy",
    "emptySearchSubtitle": "Sử dụng các từ khóa tìm kiếm khác nhau để tìm ao bạn đang tìm kiếm",
    "functionDescription": "Mô tả chức năng",
    "infoDescription": "Hướng dẫn hoạt động hàng ngày",
    "refreshDescription": "Làm mới dữ liệu hoạt động hàng ngày",
    "searchDescription": "Trường tìm kiếm tên ao",
    "incompleteDescription": "Hoạt động hàng ngày không đầy đủ",
    "completeDescription": "Các hoạt động hàng ngày đã hoàn tất",
    "hiddenDescription": "Ẩn các hoạt động hàng ngày hiện không được thực hiện",
    "changeStatusDescription": "Thay đổi trạng thái hoạt động hàng ngày nếu có lỗi",
    "settingDescription": "Tăng hoặc giảm hoạt động hàng ngày"
  },
  "chemicalParameterScreen": {
    "emptyHistoryParameterTitle": "Hoàn thành dữ liệu đăng ký của bạn",
    "emptyHistoryParameterMessage": "Để biết dự đoán hóa học, bạn cần ghi lại dữ liệu thức ăn và các thông số Vật lý (pH, Độ mặn, Nhiệt độ, DO).",
    "completeData": "Hoàn thành dữ liệu",
    "emptyMessageNewUser": "Không thể truy cập tính năng này vì bạn chưa có chu kỳ hoạt động.",
    "gotoProTitle": "Nhận các tính toán dự đoán hóa học bằng cách ghi lại dữ liệu nguồn cấp dữ liệu và chất lượng vật lý của nước (pH, độ mặn, nhiệt độ và DO).",
    "gotoProMessage": "JALA giúp bạn dự đoán dữ liệu hóa học dựa trên dữ liệu bạn ghi lại trong ứng dụng.",
    "buttonGotoPro": "Nâng cấp ngay bây giờ",
    "lowAccuracyTitle": "Độ chính xác dự đoán không tối ưu",
    "lowAccuracyMessage": "Ghi lại đầy đủ dữ liệu nguồn cấp dữ liệu và\nThông số vật lý (pH, Độ mặn, Nhiệt độ,\nDO).",
    "latestUpdateText": "Dữ liệu mới nhất {{date}}",
    "parameter": "Tham số",
    "actualValueToday": "Thật sự (DoC {{age}})",
    "estimateValueToday": "Ước tính (DoC {{age}})",
    "estimateValueDoC": "Ước tính cuối cùng\n(DoC {{age}})",
    "week": "7 Ngày",
    "month": "30 Ngày",
    "cycle": "1 Xe đạp",
    "lowAccuracyPredictionMessage": "Toàn bộ dữ liệu nguồn cấp dữ liệu và các thông số Vật lý (pH, Độ mặn, Nhiệt độ, DO) ",
    "emptyPredictionMessage": "Không thể tạo dự đoán. Vui lòng nhập bản ghi <b>dữ liệu nguồn cấp dữ liệu</b> và <b>thông số vật lý</b> để hiển thị dự đoán. ",
    "showDetail": "Xem chi tiết",
    "alkalinity": "Alkalinity",
    "hardness": "Hardness",
    "otherParameter": "Các thông số khác",
    "carbonate": "CO³",
    "bicarbonate": "HCO³",
    "calcium": "Ca",
    "magnesium": "Mg",
    "ammonia": "Ammonia",
    "nitrite": "Nitrit",
    "nitrate": "Nitrat",
    "tom": "TOM",
    "total": "Tổng cộng",
    "data": "Data",
    "beta": "Beta",
    "readDescription": "đọc giải thích",
    "sendFeedback": "Cung cấp thông tin phản hồi",
    "alertBeta": "Tính năng này vẫn đang trong giai đoạn thử nghiệm (phiên bản beta)\n<description> hoặc <feedback>.",
    "buttonBetaCard": "Đăng ký để trở thành Người thử nghiệm Beta",
    "titleBetaCard": "Nhận các tính toán dự đoán hóa học bằng cách ghi lại dữ liệu nguồn cấp dữ liệu và chất lượng vật lý của nước (pH, độ mặn, nhiệt độ và DO).",
    "messageBetaCard": "Tính năng này vẫn đang trong giai đoạn thử nghiệm và chỉ có quyền truy cập hạn chế. Nếu bạn muốn thử và cung cấp phản hồi, vui lòng gửi cho mình qua nút bên dưới",
    "titleBetaSheet": "Dự đoán thông số hóa học",
    "content1BetaSheet": "Với tính năng này, bạn có thể dự đoán dữ liệu chất lượng nước, đặc biệt là các thông số hóa học và bạn có thể sử dụng nó như một phương tiện thay thế để xác định phương pháp xử lý phù hợp nhằm luôn duy trì sự ổn định của chất lượng nước trong hồ bơi.",
    "content2BetaSheet": "Dự đoán này có thể được hiển thị khi có bản ghi dữ liệu trong ứng dụng bao gồm dữ liệu nguồn cấp dữ liệu tích lũy và các thông số vật lý chất lượng nước (pH, Độ mặn, Nhiệt độ và DO).",
    "content3BetaSheet": "Các dự đoán được đưa ra bởi một công cụ trí tuệ nhân tạo nghiên cứu chất lượng nước, khí hậu và điều kiện đầu vào thức ăn từ nhiều dữ liệu khác nhau về các ao nuôi tôm ở Indonesia.",
    "subtitle1BetaSheet": "Những thông số nào có thể được dự đoán?",
    "subtitle2BetaSheet": "Tính năng này hoạt động như thế nào?",
    "subtitle3BetaSheet": "Cách tạo dự đoán?",
    "note1BetaSheet": "Chúng tôi nhận thấy rằng tính toán này vẫn cần cải thiện, vì vậy thông tin đầu vào của bạn có ý nghĩa rất lớn đối với chúng tôi.",
    "note2BetaSheet": "<b>Lưu ý:</b> Dự đoán này không xem xét các yếu tố khác như thời tiết, màu nước, siphon và các yếu tố khác.",
    "emptyDataTitle": "Giá trị dự đoán không được hiển thị",
    "emptyDataMessage": "Dự đoán hóa học sẽ được hiển thị nếu dữ liệu ghi lại nguồn cấp dữ liệu và các thông số vật lý (pH, Độ mặn, nhiệt độ, DO) có sẵn trong ít nhất 3 ngày qua",
    "emptyCycle": "Không thể truy cập tính năng này vì bạn chưa có chu kỳ hoạt động."
  },
  "gotoJalaProScreen": {
    "buttonText": "JALA Apps Pro",
    "title": "Chuyên nghiệp hơn với\n",
    "description": "Quản lý dữ liệu canh tác với nhiều tính năng hoàn thiện hơn để trở thành thông tin chi tiết toàn diện và hữu ích.",
    "benefitTitle1": "Mục nhập Excel",
    "benefitDesc1": "Thu thập dữ liệu đầu vào canh tác ở định dạng quen thuộc hơn.",
    "benefitTitle2": "Quản lý tài chính",
    "benefitDesc2": "Quản lý, theo dõi thu chi ao nuôi.",
    "benefitTitle3": "Kho ao",
    "benefitDesc3": "Quản lý và theo dõi tình trạng ao nuôi của bạn.",
    "benefitTitle4": "Báo cáo Trồng trọt",
    "benefitDesc4": "Tạo báo cáo canh tác tự động với phân tích đầy đủ.",
    "benefitTitle5": "Chemical Predictions",
    "benefitDesc5": "Nhận dự đoán về dữ liệu hóa học bằng cách tận dụng công nghệ AI",
    "readMore": "Đọc Thêm tại ",
    "urlJalaPro": "https://jala.tech/pro",
    "upgradeNow": "Nâng cấp Ngay bây giờ",
    "upgrade": "Nâng cấp",
  }
}
